import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import './style.css'; // Import custom CSS for any additional styles
import { useState } from 'react';

const SubscriptionPlans = () => {
    const [status, setStatus] = useState("");
    const [activePlan, setActivePlan] = useState("Free");

    const handleButtonCLick = (value) => {
        setActivePlan(value)
    }
    return (
        <Container className="pricing-table py-5">
            {/* Monthly and Annually Toggle */}
            <Row className="justify-content-end mb-4 mr-1">
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                    <label className="btn btn-secondary active">
                        <input type="radio" name="options" id="monthly" autoComplete="off" defaultChecked /> Monthly
                    </label>
                    <label className="btn btn-secondary">
                        <input type="radio" name="options" id="annually" autoComplete="off" /> Annually
                    </label>
                </div>
            </Row>

            <Row className="justify-content-center g-4">
                {/* Premium Plan */}
                <Col lg="4" md="6" className="mb-4">
                    <div className={`plan-card ${activePlan === "Premium" ? "active" : ""} shadow-sm`}>
                        <div className="text-center mb-5">
                            <span className={`${activePlan === "Premium" ? "status-pill" : "badge badge-secondary plans"}`}><h5 className="mb-0">Premium</h5></span>
                        </div>
                        <div className='text-center pb-5 nex-text-base'>
                            <p>Lorem Ipsum is simply dummy text of the printing industry.</p>
                        </div>
                        <div className="plan-body text-center mb-3">
                            <p className="lead">
                                INR 5000<span className="text-muted nex-text-base">/month</span>
                            </p>

                            <Button name="Premium" className={`${activePlan === "Premium" ? "nex-btn-primary rounded-pill w-75" : "nex-btn-secondary-pill rounded-pill w-75"}`} block onClick={(event) => handleButtonCLick(event.target.name)}>Upgrade Now</Button>
                            <ul className="list-unstyled mt-3 mb-4 nex-text-xl">
                                <li>✔ Access to 10,000+ advisors</li>
                                <li>✔ Digital boardroom and forum</li>
                                <li>✔ Let any advisor join your board</li>
                                <li>✔ Dedicated account manager</li>
                                <li>✔ Moderated board meetings</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                {/* Elite Plan */}
                <Col lg="4" md="6" className="mb-4">
                    <div className={`plan-card ${activePlan === "Elite" ? "active" : ""}`}>
                        <div className="text-center mb-5">
                            <span className={`${activePlan === "Elite" ? "status-pill" : "badge badge-secondary plans"}`}><h5 className="mb-0">Elite</h5></span>
                        </div>
                        <div className='text-center pb-5 nex-text-base'>
                            <p>Lorem Ipsum is simply dummy text of the printing industry.</p>
                        </div>
                        <div className="plan-body text-center mb-3">
                            <p className="lead">
                                INR 2220<span className="text-muted nex-text-base">/month</span>
                            </p>

                            <Button name="Elite" className={`${activePlan === "Elite" ? "nex-btn-primary rounded-pill w-75" : "nex-btn-secondary-pill rounded-pill w-75"}`} block onClick={(event) => handleButtonCLick(event.target.name)}>Upgrade Now</Button>
                            <ul className="list-unstyled mt-3 mb-4 nex-text-xl">
                                <li>✔ Access to 10,000+ advisors</li>
                                <li>✔ Digital boardroom and forum</li>
                                <li>✔ Let any advisor join your board</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* Free Plan */}
                <Col lg="4" md="6" className="mb-4">
                    <div className={`plan-card ${activePlan === "Free" ? "active" : ""}`}>
                        <div className="text-center mb-5">
                            <span className={`${activePlan === "Free" ? "status-pill" : "badge badge-secondary plans"}`}><h5 className="mb-0">Free</h5></span>
                        </div>
                        <div className='text-center pb-5 nex-text-base'>
                            <p>Fds jsdh h hjhdjhhj Lorem Ipsum is simply dummy text of the printing industry.</p>
                        </div>
                        <div className="plan-body text-center mb-3">
                            <p className="lead">
                                Free
                            </p>

                            <Button name="Free" className={`${activePlan === "Free" ? "nex-btn-primary rounded-pill w-75" : "nex-btn-secondary-pill rounded-pill w-75"}`} block onClick={(event) => handleButtonCLick(event.target.name)}>Upgrade Now</Button>
                            <ul className="list-unstyled mt-3 mb-4 nex-text-xl">
                                <li>✔ Access to 10+ practitioner profiles</li>
                                <li>✔ Access to 5 Jobs</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                {/* <Col lg="4" md="6" className="mb-4">
                    <div className="plan-card shadow-sm border-light">
                        <div className="bg-light text-center">
                            <h5 className="mb-0">Elite</h5>
                        </div>
                        <div className="plan-body text-center">
                            <p className="lead">
                                INR 2220<span className="text-muted">/month</span>
                            </p>
                            <p>It is a long established fact that a reader will be distracted by readable content.</p>
                            <Button color="secondary" block>Upgrade Now</Button>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>✔ Access to 10,000+ advisors</li>
                                <li>✔ Digital boardroom and forum</li>
                                <li>✔ Vetted & hand-picked advisors</li>
                                <li>✔ Dedicated account manager</li>
                                <li>✔ Moderated board meetings</li>
                            </ul>
                        </div>
                    </div>
                </Col> */}

                {/* Free Plan */}
                {/* <Col lg="4" md="6" className="mb-4">
                    <div className="plan-card shadow-sm border-light">
                        <div className="bg-light text-center">
                            <h5 className="mb-0">Free</h5>
                        </div>
                        <div className="plan-body text-center">
                            <p className="lead">Free</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <Button color="light" block>Register Now</Button>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>&nbsp;</li>
                            </ul>
                        </div>
                    </div>
                </Col> */}
            </Row>
        </Container>
    );
};

export default SubscriptionPlans;
